module.exports = {
  RETRIEVE_OUTBOUND_HANDLER_REQUEST: 'RETRIEVE_OUTBOUND_HANDLER_REQUEST',
  RETRIEVE_OUTBOUND_HANDLER_SUCCESS: 'RETRIEVE_OUTBOUND_HANDLER_SUCCESS',
  RETRIEVE_OUTBOUND_HANDLER_FAILURE: 'RETRIEVE_OUTBOUND_HANDLER_FAILURE',
  HANDLER_CHECKED: 'HANDLER_CHECKED',
  SELECT_ALL_HANDLERS: 'SELECT_ALL_HANDLERS',
  DESELECT_ALL_HANDLERS: 'DESELECT_ALL_HANDLERS',
};
